import { useState, useEffect, useRef } from 'react';

const CounterBidTimer = (props) => {

    const { Seconds } = props;
    const [seconds, setSeconds] = useState(Seconds);
    const [data, setData] = useState("true");

    console.log(Seconds,"remainingSeconds Seconds Seconds top==========")

    const animationFrameRef = useRef(null);
    const startTimeRef = useRef(null);
    const elapsedRef = useRef(0);

    useEffect(() => {
        startTimeRef.current = Date.now();
        animationFrameRef.current = requestAnimationFrame(animationFrameCallback);

        return () => {
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, []);

    const animationFrameCallback = () => {
        elapsedRef.current = Date.now() - startTimeRef.current;
        const secondsElapsed = Math.floor(elapsedRef.current / 1000);
        const remainingSeconds = Math.max(Seconds - secondsElapsed, 0);
        // console.log(remainingSeconds,"remainingSeconds Seconds==========",seconds)
        setSeconds(remainingSeconds);

        if (remainingSeconds === 0) {
            props?.onData(data);
        }

        animationFrameRef.current = requestAnimationFrame(animationFrameCallback);
    };

    const minutes = (Seconds === null ? "" : Math.floor(seconds / 60));
    const remainingSeconds = (Seconds === null ? "" : seconds % 60);

    console.log(remainingSeconds, minutes,"remainingSeconds Seconds out==========")


    return (
        <>
            {remainingSeconds === 0 && seconds === 0 ? "" :
                <>
                    {minutes}{Seconds === null ? "" : ":"}{Seconds === null ? "" : (remainingSeconds < 10 ? '0' : '')}{remainingSeconds}
                </>}
        </>
    )
}

export default CounterBidTimer